var initCollapsibleItems;
var destroyCollapsibleItems;

(function() {
	var blockedClickHandler = function(event) {
		event.preventDefault();
		event.stopPropagation();

		return false;
	};

	initCollapsibleItems = function(className) {
		var collapsibleNavigations = document.querySelectorAll('.' + className);

		for (var i = 0 ; i < collapsibleNavigations.length; i++) {
			var navigation = collapsibleNavigations[i];

			var buttons = navigation.querySelectorAll('.' + className + '-button');
			for (var j = 0 ; j < buttons.length; j++) {
				var button = buttons[j];

				const buttonWrapper = document.createElement('span');
				const buttonAttributes = button.attributes;
				for (var attrIndex = 0; attrIndex < buttonAttributes.length; attrIndex++) {
					buttonWrapper.setAttribute(buttonAttributes[attrIndex].name, buttonAttributes[attrIndex].value);
				}
				buttonWrapper.innerHTML = button.innerHTML;
				button.parentNode.replaceChild(buttonWrapper, button);
				buttonWrapper.addEventListener('click', blockedClickHandler);
				buttonWrapper.innerHTML = '<button aria-haspopup="true" aria-expanded="false">' + buttonWrapper.innerHTML + '</button>';
				buttonWrapper.firstChild.addEventListener('click', function(event) {
					event.preventDefault();
					event.stopPropagation();

					var isExpanded = this.getAttribute('aria-expanded') === 'true' || false;

					this.setAttribute('aria-expanded', !isExpanded);

					if (!isExpanded) {
						this.parentNode.classList.add('is-active');
					} else {
						this.parentNode.classList.remove('is-active');
					}

					const content = this.parentNode.parentNode.querySelector('.' + className + '-content');
					content.style.display = isExpanded ? 'none' : '';
					content.hidden = isExpanded;
				});
			}

			var contents = navigation.querySelectorAll('.' + className + '-content');
			for (var j = 0 ; j < contents.length; j++) {
				contents[j].setAttribute('hidden', 'hidden');
				contents[j].style.display = 'none';
			}
		}
	};

	destroyCollapsibleItems = function(className) {
		var collapsibleNavigations = document.querySelectorAll('.' + className);

		for (var i = 0 ; i < collapsibleNavigations.length; i++) {
			var navigation = collapsibleNavigations[i];

			var buttonWrapper = navigation.querySelector('.' + className + '-button');
			buttonWrapper.removeEventListener('click', blockedClickHandler);
			const button = document.createElement('a');
			button.setAttribute('href', '#');
			const buttonWrapperAttributes = buttonWrapper.attributes;
			for (var attrIndex = 0; attrIndex < buttonWrapperAttributes.length; attrIndex++) {
				button.setAttribute(buttonWrapperAttributes[attrIndex].name, buttonWrapperAttributes[attrIndex].value);
			}
			button.innerHTML = buttonWrapper.innerHTML;
			buttonWrapper.parentNode.replaceChild(button, buttonWrapper);

			if (button.firstChild !== undefined) {
				button.innerHTML = '<span>' + button.firstChild.textContent + '</span>';
			}

			const content = navigation.querySelector('.' + className + '-content');
			content.style.display = '';
			content.removeAttribute('hidden');
		}
	};

	initCollapsibleItems('js-collapsible-element');
})();
